// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dab193c1","498":"6dcbec9e","703":"a08d76d4","787":"b64ace52"}[chunkId] + ".chunk.js";
};